import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dateConverter } from '../../../../helper/Helper';

class AboutCompanyCard extends Component {
    constructor(props) {
        super()

        this.state = {
        }
    }

    render() {
        const { companyData } = this.props;
        const { address, dateCreated, phone, email, companyName } = companyData;
        // const csscard = {
        //     display: "block",
        //     width: "30vw",
        //     height: "20vw"

        // }
        const date = dateConverter(dateCreated);
        const listStyleText = { fontSize: "14px" };
        return (
            <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>
                <div className="card-header bg-white p-0 mx-2 mb-2">
                    <div className="row">
                        <div className="col-12">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>Company details</p>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <ul className="list-group list-group-flush" style={{ borderRadius: '20px' }}>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Company:</b><p style={listStyleText}>{companyName}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Phone:</b> <p style={listStyleText}>{phone}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Email:</b> <p style={listStyleText}>{email}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Address:</b> <p style={listStyleText}>{address}</p></li>
                        <li className="list-group-item py-2 d-flex align-items-start" ng-repeat="i in filters" style={listStyleText}><b className="mr-2">Created on:</b><p style={listStyleText}>{date.parsedDate}</p></li>
                    </ul>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {

        companyData: state.firestore.data.Company,
    }
}



export default connect(mapStateToProps)(AboutCompanyCard)